import React from 'react';
import Layout from './../layout/Layout';
import styled from 'styled-components';


import Container from '../../common/components/Container';

const Header = styled.div.withConfig({displayName:'-Header'})`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 40px;
  margin-bottom: 40px;
`;
const Title = styled.div.withConfig({displayName:'-Title'})`
  font-family: 'Roboto',cursive;
  font-size: 30px;
`;

const Dashboard = ({layout}) => {

  return (
    <Layout layout={layout}>
      <Container>          
        <Header>
          <Title><i className="fa-solid fa-gauge"></i> Dashboard</Title>    
        </Header>
      </Container>
    </Layout>
  )
}

export default Dashboard;
